import { useEffect, useState } from "react";
import axios, { apiBaseUrl } from "../../api/axios";
import ResponsiveTable from "../../components/ResponsiveTable";
import Loader from '../../components/Loader';
import { EyeIcon, PencilIcon, TrashIcon, CurrencyDollarIcon } from "@heroicons/react/24/outline";
import ExportButtons from "../../components/ExportButtons";
import { useNavigate } from "react-router-dom";
import moment from "moment"
import { toast } from "react-toastify";

export default function BankList() {
    const navigate = useNavigate();
     const [loading, setLoading] = useState(false);
    const [showTopupModal, setShowTopupModal] = useState(false);
    const [selectedBank, setSelectedBank] = useState(null);
    const [topupAmount, setTopupAmount] = useState('');
    const [adjustType, setAdjustType] = useState('deposit'); // 'deposit' or 'withdraw'
    const [topupDescription, setTopupDescription] = useState('');
    const [expensesList, setExpensesList] = useState([])
    const getCategoryData = () => {
        setLoading(true)
        axios.get("/banks/live").then((res) => {
            setLoading(false)
            setExpensesList(res.data);
        }).catch((err)=>{
            setLoading(false)
            toast.error("Error")
        })
    }
    useEffect(() => {
        getCategoryData()
    }, []);

    const actions = [
        { label: 'Top-up', value: 'topup', icon: <CurrencyDollarIcon className="w-4 h-4 inline text-green-700" /> },
        { divider: true },
        { label: 'Edit', value: 'edit', icon: <PencilIcon className="w-4 h-4 inline" /> },
        { divider: true },
        { label: 'Delete', value: 'delete', icon: <TrashIcon className="w-4 h-4 inline text-red-600" /> },
    ];
    const handleActionClick = (action, row) => {
        switch (action) {
            case "edit":
                navigate(`/banks/edit/${row.bank_id}`);
                break;
            case "topup":
                setSelectedBank(row);
                setTopupAmount('');
                setShowTopupModal(true);
                break;
            case "delete":
                if (window.confirm("Are you sure you want to delete this Bank?")) {
                    axios.delete(`/banks/${row.bank_id}`).then(() => {
                        getCategoryData()
                    });
                }
                break;
            default:
                break;
        }
    };
    const handleDownload = (type) => {
        const url = `${apiBaseUrl}/banks/export/${type}`;
        window.open(url, "_blank");
    };
    const columns = [
        { header: "SL", accessor: "sl", render: (v, row, i) => i + 1 },
        {
            header: "Created Date", accessor: "created_at",
            render: (value, row) => <span>{moment(value, 'YYYY-MM-DD hh:mm:ss').format("DD/MM/YYYY hh:mm:ss")}</span>
        },
        { header: "Bank Name", accessor: "bank_name" },
        { header: "Account Number", accessor: "account_number" },
        {
            header: "Total Deposit", accessor: "total_deposit",
            render: (value, row) => <span className="text-green-800 font-semibold">{value} BDT</span>
        },
        {
            header: "Totoal Withdraw", accessor: "total_withdraw",
            render: (value, row) => <span className="text-red-600 font-semibold">{value} BDT</span>
        },
        {
            header: "Balance", accessor: "balance",
            render: (value, row) => <span className="text-blue-800 font-semibold">{value} BDT</span>
        },
    ];

    return (
        <div className="p-4 max-w-6xl mx-auto text-sm bg-white rounded-md">
            <div className="w-full">
                <ExportButtons title="Bank List" onDownload={handleDownload} />
                <ResponsiveTable
                    columns={columns}
                    data={expensesList}
                    showActions
                    actionButtons={actions}
                    onActionClick={handleActionClick}
                />
            </div>
            {showTopupModal && selectedBank && (
                <div className="fixed inset-0 z-50 bg-black bg-opacity-40 flex items-center justify-center">
                    <div className="bg-white rounded shadow-lg max-w-sm w-full p-6 space-y-4 relative">
                        <h2 className="text-lg font-bold mb-2">Adjust Balance: {selectedBank.bank_name}</h2>

                        <div className="flex gap-2">
                            <select
                                value={adjustType}
                                onChange={(e) => setAdjustType(e.target.value)}
                                className="w-1/2 border rounded p-2 text-sm"
                            >
                                <option value="deposit">Top-up (Deposit)</option>
                                <option value="withdraw">Withdraw</option>
                            </select>

                            <input
                                type="number"
                                placeholder="Amount"
                                className="w-1/2 border p-2 text-sm rounded"
                                value={topupAmount}
                                onChange={(e) => setTopupAmount(e.target.value)}
                            />
                        </div>

                        <textarea
                            rows={3}
                            className="w-full border p-2 text-sm rounded"
                            placeholder="Description (optional)"
                            value={topupDescription}
                            onChange={(e) => setTopupDescription(e.target.value)}
                        />

                        <div className="flex justify-end gap-3">
                            <button
                                className="px-4 py-1 bg-red-500 hover:bg-red-600 text-white text-sm rounded"
                                onClick={() => setShowTopupModal(false)}
                            >
                                Cancel
                            </button>
                            <button
                                className="px-4 py-1 bg-green-700 text-white hover:bg-green-800 text-sm rounded"
                                onClick={async () => {
                                    setLoading(true)
                                    try {
                                        await axios.post('/bank-transactions', {
                                            bank_id: selectedBank.bank_id,
                                            type: adjustType,
                                            amount: parseFloat(topupAmount),
                                            description: topupDescription || `Manual ${adjustType}`,
                                            reference_type: 'adjustment',
                                        });
                                        setLoading(false)
                                        toast.success("Balance Adjustment Successful")
                                        setShowTopupModal(false);
                                        getCategoryData();
                                    } catch (err) {
                                        setLoading(false)
                                        alert("Adjustment failed");
                                        console.error(err);
                                    }
                                }}
                            >
                                Confirm
                            </button>
                        </div>
                    </div>
                </div>
            )}
            <Loader show={loading} />
        </div>
    );
}